import React from 'react';

const ImageBlocker = ({ item }) => {
	return (
		<img className="img-fluid w-100" src={item.customFields.image.url} alt="" />
	);
}
export default ImageBlocker;

